import { SessionApply } from '../sessionType';

export const errorSession: SessionApply = (history, setState) => {
  setState({ isInitialised: true });
  history.push('/error');
};
